import React,{Component} from "react";


export class Blob3 extends Component {

    render(){
        return(
                <div className='blob3 animate-levitate'></div>
        )
    }

}